import Vue from "vue";
import { Component } from "vue-property-decorator";

import { StepUnit } from "./types";

@Component
export default class PeriodSimplifierMixin extends Vue {
  currentUnit:StepUnit | null = null

  calculateCurrentUnit(unitOptions: Array<StepUnit>, value:number, defaultUnit: StepUnit = unitOptions[0]): void {
    if (value !== 0) {
      for (const unitOption of unitOptions) {
        const unit: StepUnit = unitOption
        const remainder = value % unit

        if (value >= unit && remainder === 0) {
          this.currentUnit = unit
        }
      }
    } else {
      this.currentUnit = defaultUnit
    }
  }

  unitLabel(unit: number, value: number) {
    return this.$tc(`period_simplifier_${ unit }`, value).toString()
  }
}
